import React from 'react';
import { default as TextField } from './textField';

export default class PasswordField extends React.Component {
    render() {
        var props = {
            ...this.props,
            type: "password"
        };

        return (<TextField {...props} />);
    }
}